import React from 'react'
import { useTranslation } from 'react-i18next'

type TransactionTooltipContentProps = {
  isSegmentationWithoutCta: boolean
}

export const TransactionTooltipContent: React.FC<TransactionTooltipContentProps> = ({ isSegmentationWithoutCta }) => {
  const { t } = useTranslation()
  const shortTermAccommodationDescription = isSegmentationWithoutCta
    ? t('segmentation.tooltips.transaction.shortTermAccommodation.descriptionWithoutCta')
    : t('segmentation.tooltips.transaction.shortTermAccommodation.description')

  return (
    <div className={'grid grid-flex gap-m'}>
      <div className={'grid-item'}>
        <span className={`font-body-medium-bold`}>{t('segmentation.tooltips.transaction.rent.label')} </span>
        <span className={`font-body-medium-regular`}>{t('segmentation.tooltips.transaction.rent.description')}</span>
      </div>
      <div className={'grid-item'}>
        <span className={`font-body-medium-bold`}>{t('segmentation.tooltips.transaction.sell.label')} </span>
        <span className={`font-body-medium-regular`}>{t('segmentation.tooltips.transaction.sell.description')}</span>
      </div>
      <div className={'grid-item'}>
        <span className={`font-body-medium-bold`}>
          {t('segmentation.tooltips.transaction.shortTermAccommodation.label')}{' '}
        </span>
        <span className={`font-body-medium-regular`}>{shortTermAccommodationDescription}</span>
      </div>
    </div>
  )
}
